<template>
  <div class="dostavka">
    <div class="shop_banner_area mb-30">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="shop_banner_thumb">
              <img src="/img/otchetnost.jpg" alt="" />
            </div>
            <div class="page_title">
              <h1>Отчётность Контур.Экстерн</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="breadcrumbs_area mt-30 mb-30">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="breadcrumb_content">
              <ul>
                <li><router-link :to="'/'">Главная</router-link></li>
                <li>Отчётность Контур.Экстерн</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container mb-30">
      <div class="row">
        <div class="col-12">
          <h3 class="mb-3">Отчётность через интернет</h3>
          <p>
            Воспользуйтесь современными возможностями сдачи отчётности в ФНС, ПФР, ФСС, Росстат, РАР, РПН. Контур.Экстерн позволит сдать отчётность быстро и без
            ошибок. Сервис не требует установкии и обновления &dash; формы отчётности всегда актуальны, встроенные проверки помогут сдать отчётность с первого
            раза.
          </p>
          <OrderButton name="connect" variant="warning" title="Подключить сейчас" pill interest="Подключение Контур.Отчётность"></OrderButton>
          <OrderButton
            name="connect-free"
            variant="outline-warning"
            title="Попробовать бесплатно"
            pill
            interest="Бесплатно попробовать Контур.Отчётность"
            style="margin-left: 10px"
          ></OrderButton>
          <b-img center src="/img/logo/kontur-extern.png" alt="Контур.Экстерн" style="max-height: 100px"></b-img>
        </div>
      </div>
    </div>

    <div class="our_services mb-45">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="services_title">
              <h2>Сдача отчётности в контролирующие органы</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2 col-md-4 col-sm-6">
            <div class="services_desc text-center">
              <img src="/img/logo/fns.png" class="mb-3" style="height: 48px" />
              <p>Федеральная налоговая служба РФ</p>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6">
            <div class="services_desc text-center">
              <img src="/img/logo/pfr.png" class="mb-3" style="height: 48px" />
              <p>Пенсионный фонд РФ</p>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6">
            <div class="services_desc text-center">
              <img src="/img/logo/rosstat.png" class="mb-3" style="height: 48px" />
              <p>Росстат РФ</p>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6">
            <div class="services_desc text-center">
              <img src="/img/logo/fss.png" class="mb-3" style="height: 48px" />
              <p>Фонд социального страхования РФ</p>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6">
            <div class="services_desc text-center">
              <img src="/img/logo/rar.png" class="mb-3" style="height: 48px" />
              <p>РАР РФ</p>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6">
            <div class="services_desc" style="text-align: center">
              <img src="/img/logo/rpn.png" class="mb-3" style="height: 48px" />
              <p>РПН РФ</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container mb-45">
      <div class="row">
        <div class="col-12">
          <h4 class="mb-3">Дополнительные модули:</h4>
          <p><strong>1С</strong> &mdash; подготовка и отправка отчётности прямо из программы 1С</p>
          <p><strong>Нулевая отчётность</strong> &mdash; подготовка и отправка нулевой отчётности в контролирующие органы</p>
          <p><strong>НДС+ (Сверка)</strong> &mdash; сверка счетов-фактур с контрагентами</p>
          <p><strong>Алкогольная отчётность</strong> &mdash; формирование, сверка и подписание деклараций 11 и 12 форм в Росалкогольрегулирование</p>
          <p><strong>Отчётность в РПН</strong> &mdash; подготовка и отправка отчётов Росприроднадзор</p>
          <p><strong>Светофор</strong> &mdash; автоматическая проверка контрагентов</p>
          <p><strong>Контроль рисков для бизнеса</strong> &mdash; уведомления о событиях, которые могут повлечь блокировку счёта или штраф</p>
        </div>
      </div>
    </div>

    <div class="container mb-45">
      <div class="row">
        <div class="col-12">
          <h3 class="mb-4">Возможности Контур.Экстерн:</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <h4>
            <b-icon icon="calendar-check" variant="primary" style="margin-right: 10px"></b-icon>
            <span class="align-baseline"> Отчитывайтесь быстро и без ошибок</span>
          </h4>
          <p class="font-weight-light mb-4">
            Контур.Экстерн возьмет на себя расчеты, контроль за сроками сдачи отчетов, сверку с бюджетом и заполнение платежек.
          </p>
        </div>
        <div class="col-lg-6 col-md-12">
          <h4>
            <b-icon icon="front" variant="primary" style="margin-right: 10px"></b-icon>
            <span class="align-baseline"> Устанавливать обновления не придется</span>
          </h4>
          <p class="font-weight-light mb-4">
            Экстерн обновляется автоматически, не отнимая ваше время и интернет-трафик. Формы отчетности и системы проверки в Экстерне всегда актуальны —
            заходите и начинайте работать.
          </p>
        </div>
        <div class="col-lg-6 col-md-12">
          <h4>
            <b-icon icon="calendar-week" variant="primary" style="margin-right: 10px"></b-icon>
            <span class="align-baseline"> Контролируйте отчеты организаций на обслуживании</span>
          </h4>
          <p class="font-weight-light mb-4">
            Отслеживайте сроки и статусы отчетности всех организаций с помощью интерактивной таблицы в Экстерне. Вам больше не придется заполнять таблицы в
            Excel и клеить стикеры на доску.
          </p>
        </div>
        <div class="col-lg-6 col-md-12">
          <h4>
            <b-icon icon="inbox" variant="primary" style="margin-right: 10px"></b-icon>
            <span class="align-baseline"> Получайте оповещения о требованиях из ИФНС</span>
          </h4>
          <p class="font-weight-light mb-4">
            Прямо в Экстерне получайте требования из налоговой и вовремя отвечайте на них в электронном виде. Это позволит не допустить штрафов и блокировки
            расчетного счета.
          </p>
        </div>
        <div class="col-lg-6 col-md-12">
          <h4>
            <b-icon icon="phone" variant="primary" style="margin-right: 10px"></b-icon>
            <span class="align-baseline">СМС оповестит о сдаче отчета</span>
          </h4>
          <p class="font-weight-light mb-4">
            Информация о статусе отчета будет оперативно поступать на ваш мобильный телефон или на электронную почту. Настройте сервис уведомлений так, как вам
            удобно.
          </p>
        </div>
        <div class="col-lg-6 col-md-12">
          <h4>
            <b-icon icon="wallet-fill" variant="primary" style="margin-right: 10px"></b-icon>
            <span class="align-baseline">Откажитесь от дорогих справочно-правовых программ</span>
          </h4>
          <p class="font-weight-light mb-4">
            Абонентам Экстерна доступна актуальная справочно-правовая база. В вашем распоряжении федеральное и региональное законодательство, формы документов,
            авторские статьи по каждому направлению отчетности, арбитражная практика и многое другое.
          </p>
        </div>
        <div class="col-lg-6 col-md-12">
          <h4>
            <b-icon icon="journal-text" variant="primary" style="margin-right: 10px"></b-icon>
            <span class="align-baseline">Получайте выписки из ЕГРЮЛ и ЕГРИП</span>
          </h4>
          <p class="font-weight-light mb-4">
            В несколько кликов заказывайте выписки ЕГРЮЛ и получайте открытую информацию о контрагентах. Вам доступны основные данные о любом юридическом лице
            или индивидуальном предпринимателе в России.
          </p>
        </div>
        <div class="col-lg-6 col-md-12">
          <h4>
            <b-icon icon="arrow-left-right" variant="primary" style="margin-right: 10px"></b-icon>
            <span class="align-baseline">Обменивайтесь электронными документами с контрагентами</span>
          </h4>
          <p class="font-weight-light mb-4">
            Вы сможете бесплатно отправить контрагентам 50 электронных юридически значимых документов (накладные, торг-12, счета-фактуры и т.д.). Они дойдут до
            адресата за секунды.
          </p>
        </div>
        <div class="col-lg-6 col-md-12">
          <h4>
            <b-icon icon="card-checklist" variant="primary" style="margin-right: 10px"></b-icon>
            <span class="align-baseline">Сверяйте счета-фактуры</span>
          </h4>
          <p class="font-weight-light mb-4">
            Загрузите свою книгу продаж и пригласите для сверки контрагентов. Чтобы загружать книги покупок, сверять книги покупок и продаж с контрагентами,
            получите доступ к сервису Контур.НДС+.
          </p>
        </div>
        <div class="col-lg-6 col-md-12">
          <h4>
            <b-icon icon="stoplights" variant="primary" style="margin-right: 10px"></b-icon>
            <span class="align-baseline">Будьте в курсе, когда к вам приедут с проверкой</span>
          </h4>
          <p class="font-weight-light mb-4">
            На основании данных из бухгалтерской отчетности сервис Эксперт проведет финансовый анализ вашего предприятия. А с помощью методики, используемой
            ФНС, рассчитает вероятность налоговых и административных проверок.
          </p>
        </div>
        <div class="col-lg-6 col-md-12">
          <h4>
            <b-icon icon="file-medical" variant="primary" style="margin-right: 10px"></b-icon>
            <span class="align-baseline">Формируйте и сдавайте электронные больничные</span>
          </h4>
          <p class="font-weight-light mb-4">
            Выполняйте все необходимые действия при работе с электронными листами нетрудоспособности: скачивайте с портала ФСС, заполняйте, распечатывайте и
            отправляйте в ФСС. Если ваш регион участвует в программе по прямым выплатам, вы можете подготовить в Контур.Экстерне реестр и передать его в ФСС.
          </p>
        </div>
        <div class="col-lg-6 col-md-12">
          <h4>
            <b-icon icon="receipt" variant="primary" style="margin-right: 10px"></b-icon>
            <span class="align-baseline">Создавайте платежные документы</span>
          </h4>
          <p class="font-weight-light mb-4">
            Формируйте платежные поручения на основании требования или налоговой декларации. Выберите расчетный счет, остальные данные подставит Экстерн.
          </p>
        </div>
      </div>
    </div>

    <MakeCall title="Позвоните мне" icon="telephone"></MakeCall>

    <div class="container mb-45 mt-30">
      <div class="row">
        <div class="col-12">
          <p class="text-center">
            <img src="/img/partner/kontur.png" alt="" style="max-height: 60px" />
          </p>
          <p class="text-center">
            Компания ДАТАКАТ является официальным сервисным центром
            <a href="https://kontur.ru" target="_blank">компании СКБ Контур</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MakeCall from "../components/MakeCall"
import OrderButton from "../components/OrderButton"
export default {
  name: "Otchetnost",
  components: {
    MakeCall,
    OrderButton,
  },
  data: () => ({}),
}
</script>
